// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3z0oM","consentsList":"PatientConsents_consentsList__3XM6i","consentsListEmpty":"PatientConsents_consentsListEmpty__35yqa"};